
let $;
$ = require('jquery');

export function showStatusInformer(time, text) {
  const $informer = $(".status_informer");
  $informer.find("p").html(text);
  $informer.addClass("active");
  setTimeout(() => {
    $informer.removeClass("active");
  }, time);
}